export default __webpack_public_path__ + "static/media/student_two.d5641b65.png";